module.exports = __webpack_public_path__ + "static/img/3s-platform-img4.0fb1ece.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3s-platform-img4.png
// module id = 86us
// module chunks = 0